export default {"src":"/_next/static/image/public/logos/alpaca-logo.378bc849110e0cd63ea58eabd198c72c.svg","height":171,"width":168};